// Countries where AML (Anti-Money Laundering) rules apply
export const AML_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'CY',
  'CZ',
  'DE',
  'DK',
  'EE',
  'ES',
  'FI',
  'FR',
  'GB',
  'GF',
  'GI',
  'GP',
  'GR',
  'HR',
  'HU',
  'IE',
  'IS',
  'IT',
  'LT',
  'LI',
  'LU',
  'LV',
  'MQ',
  'MT',
  'NE',
  'NL',
  'NO',
  'PL',
  'PT',
  'RE',
  'RO',
  'SE',
  'SI',
  'SJ',
  'SK',
  'SM',
  'VA',
  'YT',
];

export const APP_NAME = 'CHECKOUTUINODEWEB_ONBOARDING_LITE';

// Waiting for legal to approve these two countries for the new BFX experience
export const DCC_INELIGIBLE_COUNTRIES = ['HU', 'IL'];

// Every country PayPal supports has English enabled, so we fallback to that
export const DEFAULT_ENABLED_LANGUAGES = ['en'];

// These countries are part of GROUP-EMEA but have different legal content
export const EMEA_LITE_COUNTRIES = [
  'BG',
  'CY',
  'GF',
  'GI',
  'HR',
  'LI',
  'MQ',
  'RE',
  'SM',
  'VA',
  'YT',
];

export const FRAUD_NET_FIELD_LIST = [
  // FI fields
  { id: 'cardCvv', min: 3 },
  { id: 'cardExpiry', min: 7 },
  { id: 'cardNumber', min: 8 },

  // Contact information
  { id: 'email', min: 13 },
  { id: 'firstName', min: 5 },
  { id: 'lastName', min: 5 },
  { id: 'phone', min: 10 },

  // Address fields
  { id: 'city', min: 5 },
  { id: 'line1', min: 5 },
  { id: 'line2', min: 2 },
  { id: 'postalCode', min: 5 },
  { id: 'state', min: 2 },

  // Signup fields
  { id: 'dob', min: 8 },
  { id: 'password', min: 8 },
];

export const GEO_REGIONS = ['APAC', 'EMEA', 'LATAM'];

export const KYC_DOB_NATIONALITY = ['DateOfBirth', 'Nationality'];

export const KYC_DOB_NATIONALITY_ID = [
  'DateOfBirth',
  'Nationality',
  'IdentityDocumentType',
  'IdentityDocumentNumber',
];

export const LOG_PREFIX = /^weasley_/i;
